import { Component, OnInit } from '@angular/core';
import { SubscriptionService } from '../../../services/subscription.service';
import { PaymentsService } from '../../../services/payments-service';
import { ModalService } from '../../../services/modals.service';
import { GoogleAnalyticsService } from '../../../services/google-analytics.service';
import { responseIsSuccess } from '../../../shared/helper-functions';
import { openModal, closeModalWithoutRemovingBackdrop } from '../../../shared/modal-functions';
import { subscriptionViewSpanish } from '../subscription.static.data';
declare var jQuery: any;

@Component({
  selector: 'app-payment-history',
  templateUrl: './payment-history.component.html',
  styleUrls: ['../../../app.component.css']
})
export class PaymentHistoryComponent implements OnInit {
  subscriptionView: any;
  openModal: any;
  closeModalWithoutRemovingBackdrop: any;
  togglePaymentDetails: boolean;
  paymentDetails: object;
  
  constructor(public subscriptionService: SubscriptionService, public paymentsService: PaymentsService, public modalService: ModalService, public googleAnalyticsService: GoogleAnalyticsService) {
    this.togglePaymentDetails = false;
    this.subscriptionView = subscriptionViewSpanish;
    this.openModal = openModal;
    this.closeModalWithoutRemovingBackdrop = closeModalWithoutRemovingBackdrop;
    this.paymentsService.getPaymentHistoryList(this.subscriptionService.selectedSubscriptionId);
   }

  ngOnInit() {
  }

  openPaymentDetails(ePaymentId) {
    this.paymentsService.getPaymentDetails(this.subscriptionService.selectedSubscriptionId, ePaymentId).subscribe(
      (response) => {
        if(responseIsSuccess(response)) {
          this.togglePaymentDetails = true;
          this.paymentDetails = response['CMS_SAM_Get_PaymentHistoryDetail'][0];
        } else {
          this.openModal('#errorInTransactionModal');    
        }
      });
  }

  print() {
    window.print();
  }

  submitGAEvent(eventCategory, eventAction, eventLabel) {
    this.googleAnalyticsService.emitEvent(eventCategory, eventAction, eventLabel, null);
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src4156872633/src/src/app/components/subscription/payment-history/payment-history.component.ts